
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.GpsGap = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Greenmile.Utils.getResourceWithUnitMetric('event.gpsgap.distance'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'gps_gap_distanceMeters',
                message: 'Distance for GPS Gap is requerid',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    'name': 'gps_gap_distanceMeters',
                    'maxlength': '10',
                    alt: '',
                    'value': '',
                    'size': '11',
                    id: 'gps_gap_distanceMeters',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    let value,
      formatedValue = null;

    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      if (Monet.Session.User.unitSystem !== 'METRIC') {
        value = new BigInt(jsonParam.distanceMeters) * 0.00062137;
        formatedValue = ((Math.round(value * 100)) / 100);
      } else {
        formatedValue = jsonParam.distanceMeters;
      }

      $('#gps_gap_distanceMeters').val(formatedValue);
    }
  },
  retrieveParameter() {
    let distance;

    if (Monet.Session.User.unitSystem !== 'METRIC') {
      distance = $('#gps_gap_distanceMeters').val() / 0.00062137;
    } else {
      distance = $('#gps_gap_distanceMeters').val();
    }

    distance = parseInt(distance, 10);

    return JSON.stringify({
      distanceMeters: distance,
    });
  },

};
